import { GridColDef } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import React from "react";

interface GetProspectTableColumnsParams {
  statuses: string[];
  handleNavigate: (id: number | null | undefined) => void;
  openDeleteModal: (id: number) => void;
}

export const getProspectTableColumns = ({
  statuses,
  handleNavigate,
  openDeleteModal,
}: GetProspectTableColumnsParams): GridColDef[] => [
  {
    field: "CompanyName",
    headerName: "Company Name",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "ProspectStatus",
    headerName: "Status",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
    type: "singleSelect",
    valueOptions: () => statuses,
    renderCell: (params) => {
      const backgroundColor =
        params.value === "New Prospect"
          ? "#d7f7fc"
          : params.value === "Contacted"
          ? "#d7fce4"
          : params.value === "Replied"
          ? "#f3fcd7"
          : params.value === "Warm Lead"
          ? "#f3fcd7"
          : params.value === "Qualified Lead"
          ? "#fcf6d7"
          : params.value === "Proposal Stage"
          ? "#fce6d7"
          : params.value === "Negotiation Stage"
          ? "#fcd7d7"
          : params.value === "Closed Won"
          ? "#fcd7f1"
          : params.value === "Closed Lost"
          ? "#e6d7fc"
          : "inherit";

      return (
        <Box
          sx={{
            backgroundColor,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {params.value}
        </Box>
      );
    },
  },
  {
    field: "FirstName",
    headerName: "First Name",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "LastName",
    headerName: "Last Name",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "TitleDescription",
    headerName: "Title",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "Phone",
    headerName: "Phone",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "Email",
    headerName: "Email",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "SicCodeDescription",
    headerName: "Industry",
    flex: 1,
    editable: true,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "ConsultantName",
    headerName: "Consultant",
    flex: 1,
    editable: false,
    minWidth: 20,
    resizable: true,
  },
  {
    field: "Events",
    headerName: "Events",
    flex: 1,
    maxWidth: 110,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Button
        startIcon={<EditCalendarIcon />}
        onClick={() => handleNavigate(params.row.Id)}
        variant="contained"
        color="primary"
        size="small"
        style={{ height: "26px" }}
      >
        Events
      </Button>
    ),
    resizable: true,
  },
  {
    field: "Delete",
    headerName: "Delete",
    flex: 1,
    maxWidth: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Button
        onClick={() => openDeleteModal(params.row.Id)}
        variant="outlined"
        color="error"
        size="small"
      >
        Delete
      </Button>
    ),
    resizable: true,
  },
];
